import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ListAssigned, ProjectDetailsDto, ListWeek, ListProgress, ListStages, ListRisksMatrix, ListMilestones, ViewRisk, ListDependence } from '../../../interfaces/project/list/projectDetailsDto';
import { stageProject } from 'src/app/web/interfaces/project/stages/stageProject';
import { DataTableDirective } from 'angular-datatables';
import { Subject, Subscription } from 'rxjs';
import { formatDate } from '@angular/common';
import { TableOneSearch } from 'src/app/web/util/formatDataTable';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';

export class listPay {

  projects_id: number;
  project_attachments_id: number;
  money_type_id: number;
  title: string;
  pay_amount: string;
  amount_percent: number;
  scheduled_date: string;
}
@Component({
  selector: 'app-create-pay-project',
  templateUrl: './create-pay-project.component.html',
  styleUrls: ['./create-pay-project.component.scss']
})
export class CreatePayProjectComponent implements OnInit, AfterViewInit, OnDestroy {


  title = "Datos"
  idProject: number;
  nameProject:string;
  projectStages: stageProject[] = [];
  developersTeam: ListAssigned[] = [];
  createPay: listPay;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  dtOptions = TableOneSearch();
  listAnexo: any[] = [];
  listMoney: any[] = [];
  private apiService: ApiServiceProject;
  createPayForm: FormGroup;
  idSubscription: Subscription;

  

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private errorService:ErrorService

  ) {
    
    this.route.params.subscribe((params) => {
      this.idProject = params['id_project'];
      this.nameProject = params['name'];
    });
  }

  ngOnInit(): void {
    

    this.createPayForm = this.fb.group({
      projects_id: [0],
      project_attachments_id: [0],
      money_type_id: [0],
      title: [''],
      pay_amount: [''],
      amount_percent: [''],
      scheduled_date: ['']
    });

    this.apiService =  new ApiServiceProject(this.http);
    this.spinner.show();
    this.apiService.getService('list-project-assigned-project?id_project=' + this.idProject).subscribe({
      next: (rs: any) => {


        if (rs.code == null) {
          // si la respuesta no tiene error pero no tiene data se manda un mensaje de error y se retorna al home
          if (rs == '' || rs == null) {
            this.spinner.hide();
            Swal.fire({
              title: 'No se encontraron registros',
              text: '',
              icon: 'info',
              confirmButtonText: 'Aceptar',
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed || res.isDismissed) {
                this.router.navigate(['home']);
              }
            });
          }
          // this.listPerson = rs.listAssigned;
          this.spinner.hide();
          this.rerender();
        } else {

          this.spinner.hide();
          Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
        }
      },
      error: (error) => {
        this.errorService.error(error);
      },
    });
    this.apiService.getService('list-project-play-option?id_project=' + this.idProject).subscribe({
      next: (rs: any) => {

        if (rs.code == null) {
          // si la respuesta no tiene error pero no tiene data se manda un mensaje de error y se retorna al home
          if (rs == '' || rs == null) {
            this.spinner.hide();
            Swal.fire({
              title: 'No se encontraron registros',
              text: '',
              icon: 'info',
              confirmButtonText: 'Aceptar',
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed || res.isDismissed) {
                this.router.navigate(['home']);
              }
            });
          }
          this.listAnexo = rs.listPlayOptionAnexo;
          this.listMoney = rs.listPlayOption;
          this.spinner.hide();
          this.rerender();
        } else {

          this.spinner.hide();
          Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
        }
      },
      error: (error) => {
        this.errorService.error(error);
      },
    });
    this.dtOptions = TableOneSearch()
   



  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.idSubscription.unsubscribe();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  transformName(name: string): string {
    let names = name.split('.');
    let nameString = "";
    for (let name of names) {
      nameString += name.charAt(0).toUpperCase() + name.slice(1) + " ";
    }
    return nameString;
  }



  formSubmit(): void {
    this.spinner.show();
    
    // if (this.createPayForm.value.user_id === '' || this.createPayForm.value.user_id === 0) {
    //   this.spinner.hide();
    //   Swal.fire('Debe seleccionar una etapa', '', 'error');
    //   return;
    // }

    // if (this.createPayForm.value.type_id === '') {
    //   this.spinner.hide();
    //   Swal.fire('Debe rellenar un título', '', 'error');
    //   return;
    // }

    // if (this.createPayForm.value.start_date === '') {
    //   this.spinner.hide();
    //   Swal.fire('Debe seleccionar una fecha de inicio', '', 'error');
    //   return;
    // }

    // if (this.createPayForm.value.end_date === '') {
    //   this.spinner.hide();
    //   Swal.fire('Debe seleccionar una fecha de fin', '', 'error');
    //   return;
    // }

    // if (this.createPayForm.value.assigned === '') {
    //   this.spinner.hide();
    //   Swal.fire('Debe seleccionar un estado', '', 'error');
    //   return;
    // }

   
 



    this.createPay = this.createPayForm.value;
    this.createPay.projects_id = Number(this.idProject);
    this.createPay.project_attachments_id = this.createPayForm.value.project_attachments_id.id;
    this.createPay.money_type_id = this.createPayForm.value.money_type_id.id;
    this.createPay.pay_amount = this.createPayForm.value.pay_amount;
    this.createPay.title = this.createPayForm.value.title;
    this.createPay.amount_percent = Number(this.createPayForm.value.amount_percent);
    this.createPay.scheduled_date = this.createPayForm.value.scheduled_date;
    this.createPay.scheduled_date = moment(this.createPay.scheduled_date).format("DD-MM-YYYY");


    this.apiService
      .postService('project-play-add', this.createPay)
      .subscribe({
        next: (data: any) => {
          this.spinner.hide();
          Swal.fire({title: 'Se ha creado el pago correctamente',text: '',icon: 'success',heightAuto: false})
            .then(() => [this.router.navigate(['/pdg/project/pay/list/'])
            ])
        },
        error: (error) => {
          this.errorService.error(error);
        }
      });
  }
}